import {createStyles} from "@mantine/core";

export const useSetupIntentStyles = createStyles((theme) => ({
    container: {
        height: '100vh',
        width: '100vw',
        position: 'fixed',
        top: 0,
        left: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    }
}))
